import React from "react";
import { connect } from "react-redux";

import { MenuItem } from "../../types/system/MenuItem";
import { IAppState } from "../../state/Store";
import MainMenuCollection from "./MainMenuCollection";
import { setSelectedMenuItem } from "../../state/system/Menu";
import ApplicationState from "../../foundation/AppState";

import "./MainMenu.scss";
import { ContextMenuContext } from "../contextmenu/ContextMenuContext";
import ContextFragment from "../contextmenu/ContextFragment";
import ContextMenuItem from "../contextmenu/ContextMenuItem";
import {
    clearExpandedMenuItems,
    setExpandedMenuItems,
} from "../../state/system/UIConfiguration";

interface MenuProps {
    enabled: boolean;
    items: MenuItem[];
    collapsed: boolean;

    menuItemClicked?: Function;

    setSelectedMenuItem: (item: MenuItem) => void;
    setExpandedMenuItems: (ids: string[]) => void;
    clearExpandedMenuItems: () => void;
}

interface MenuState {}

class MainMenu extends React.Component<MenuProps, MenuState> {
    static contextType = ContextMenuContext;
    context!: React.ContextType<typeof ContextMenuContext>;

    state = {};

    constructor(props: MenuProps) {
        super(props);

        const selected = this.findSelected();
        if (selected) this.itemClicked(selected);
    }

    itemClicked = (item: MenuItem) => {
        this.props.setSelectedMenuItem(item);
        this.props.menuItemClicked && this.props.menuItemClicked(item);
    };

    findSelected() {
        const path = window.location.pathname;
        const findItem = (items: MenuItem[]): MenuItem => {
            for (let item of items) {
                if (item.path === path) return item;
                if (item.children && item.children.length > 0) {
                    const found = findItem(item.children);
                    if (found) return found;
                }
            }
            return null;
        };
        return findItem(this.props.items);
    }

    expandAll() {
        const getAllIds = (items: MenuItem[]): string[] => {
            let ids = [];
            for (let item of items) {
                ids.push(item.id);
                if (item.children && item.children.length > 0) {
                    ids = ids.concat(getAllIds(item.children));
                }
            }
            return ids;
        };
        this.props.setExpandedMenuItems(getAllIds(this.props.items));
    }

    collapseAll() {
        this.props.clearExpandedMenuItems();
    }

    render() {
        const selected = this.findSelected();

        return (
            <>
                <section
                    className={`tree-menu ${
                        this.props.enabled ? "enabled" : ""
                    }`}
                    data-contextkey="main-menu">
                    <MainMenuCollection
                        items={this.props.items}
                        collapsed={this.props.collapsed}
                        selected={selected}
                        menuItemClicked={this.itemClicked}
                    />
                </section>

                <ContextFragment name="main-menu">
                    <ContextMenuItem
                        id="menu_spacer_0"
                        separator={true}
                        contextKey="main-menu"
                        order={0}
                    />
                    <ContextMenuItem
                        id="expand_all"
                        icon="add"
                        name="Expand All"
                        contextKey="main-menu"
                        handler={this.expandAll.bind(this)}
                        order={1}
                    />
                    <ContextMenuItem
                        id="collapse_all"
                        icon="remove"
                        name="Collapse All"
                        contextKey="main-menu"
                        handler={this.collapseAll.bind(this)}
                        order={2}
                    />
                </ContextFragment>
            </>
        );
    }
}

const mapStateToProps = (state: IAppState) => {
    return {
        enabled: true,
        items: ApplicationState.instance.menuItems,
    };
};

const mapDispatchToProps = (dispatch: any) => {
    return {
        setSelectedMenuItem: (item: MenuItem) =>
            dispatch(setSelectedMenuItem(item)),
        setExpandedMenuItems: (ids: string[]) =>
            dispatch(setExpandedMenuItems(ids)),
        clearExpandedMenuItems: () => dispatch(clearExpandedMenuItems()),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(MainMenu);
